"use strict";

exports.__esModule = true;
exports.identifyTag = void 0;

var _Identifiers = require("../../types/Identifiers");

var identifyTag = function identifyTag(seoTag) {
  var type = seoTag.type;

  switch (type) {
    case 'link':
      {
        return _Identifiers.GENERAL_IDENTIFIERS.LINK;
      }

    case 'meta':
      {
        if ('property' in seoTag.props) {
          return _Identifiers.GENERAL_IDENTIFIERS.OG_TAG;
        }
      }
    // eslint-disable-next-line no-fallthrough

    default:
      {
        return _Identifiers.GENERAL_IDENTIFIERS.STANDARD_META;
      }
  }
};

exports.identifyTag = identifyTag;